export default "__VITE_ASSET__bd3b4262__"